import React, { useState } from "react";
import { ColumnProps } from "antd/lib/table/interface";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import useRequest from "../../../../utils/useRequest";
import {
    getExamStudentPrintScreenList,
    StudentPrintScreenListItem
} from "../../../../service/exam";
import InvigilationProvider from "../context";
import AsidePhotoList from "./components/AsidePhotoList";

export default function ScreenCaptureRecord() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getExamStudentPrintScreenList({ studentName, examId }),
        {},
        [examId, studentName]
    );

    const columns: ColumnProps<StudentPrintScreenListItem>[] = [
        {
            title: "抓屏记录",
            dataIndex: "printScreenNum",
            align: "center"
        }
    ];

    return (
        <InvigilationProvider
            examId={examId}
            setExamId={setExamId}
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}>
            <Layout
                title="考生抓屏记录"
                refresh={refresh}
                table={
                    <StuTable
                        onErrChange={refresh}
                        extraColumns={columns}
                        dataSource={data?.dataList || []}
                        loading={loading}
                    />
                }
                aside={<AsidePhotoList />}
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
